"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFontCss = exports.setMouseMode = exports.getMouseMode = void 0;
var MOUSE_MODE_ID = 'mouseMode';
var mouseModeEnabled = false;

var addLink = function addLink(elementId, href) {
  var link = document.getElementById(elementId);

  if (!link) {
    link = document.createElement('link');
    link.rel = 'stylesheet';
    link.id = elementId;
    link.href = href;
    document.head.appendChild(link);
  }
};

var removeLink = function removeLink(elementId) {
  var link = document.getElementById(elementId);

  if (link) {
    document.head.removeChild(link);
  }
};

var getMouseMode = function getMouseMode() {
  return mouseModeEnabled;
};

exports.getMouseMode = getMouseMode;

var setMouseMode = function setMouseMode(mouseMode, mouseModeHref) {
  if (mouseMode) {
    // Need to remove existing link first to ensure styles are applied in the correct order
    removeLink(MOUSE_MODE_ID);
    addLink(MOUSE_MODE_ID, mouseModeHref);
    mouseModeEnabled = true;
  } else {
    removeLink(MOUSE_MODE_ID);
    mouseModeEnabled = false;
  }
};

exports.setMouseMode = setMouseMode;

var addFontCss = function addFontCss() {
  var fontHref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'https://files.connectwise.com/UI/Styles/font.css';
  addLink('font_css', fontHref);
};

exports.addFontCss = addFontCss;